//docks method
import products from "../store/products";
//action types
const Added = "Add_To_Cart";
const Removed = "Removed_From_Cart";
const Adjust = "Adjust_Quantity";

//action
export const AddToCart = (id) => {
  return {
    type: Added,
    payload: {
      id,
    },
  };
};

export const RemoveFromCart = (id) => {
  return {
    type: Removed,
    payload: {
      id,
    },
  };
};

export const AdjustQuantity = (id, qty, color, capacity) => {
  return {
    type: Adjust,
    payload: {
      id,
      qty,
      color,
      capacity,
    },
  };
};
//state
const initialState = {
  products: products,
  cart: [],
};
//Reducers
const storereducer = (state = initialState, action) => {
  switch (action.type) {
    case Added:
      const item = state.products.find(
        (items) => items.id === action.payload.id
      );
      const incart = state.cart.find((items) => items.id === action.payload.id)
        ? true
        : false;
      return {
        ...state,
        cart: incart
          ? state.cart.map((items) =>
              items.id === action.payload.id
                ? { ...items, qty: items.qty + 1 }
                : items
            )
          : [...state.cart, { ...item, qty: 1 }],
      };
    case Removed:
      return {
        ...state,
        cart: state.cart.filter((items) => items.id !== action.payload.id),
      };
    case Adjust:
      const cartitem = state.products.find(
        (items) => items.id === action.payload.id
      );
      const cart = state.cart.find((items) => items.id === action.payload.id)
        ? true
        : false;
      return {
        ...state,
        cart: cart
          ? state.cart.map((items) =>
              items.id === action.payload.id
                ? {
                    ...items,
                    qty: +action.payload.qty,
                    color: action.payload.color,
                    capacity: action.payload.capacity,
                  }
                : items
            )
          : [
              ...state.cart,
              {
                ...cartitem,
                qty: +action.payload.qty,
                color: action.payload.color,
                capacity: action.payload.capacity,
              },
            ],
      };
    default:
      return state;
  }
};
export default storereducer;
